var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70801 8.479H16.2913",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7292 14.729H13.1667C13.0285 14.729 12.8961 14.6741 12.7984 14.5765C12.7007 14.4788 12.6458 14.3463 12.6458 14.2082V12.6457H5.35417V14.2082C5.35417 14.3463 5.29929 14.4788 5.20162 14.5765C5.10394 14.6741 4.97147 14.729 4.83333 14.729H3.27083C3.1327 14.729 3.00022 14.6741 2.90255 14.5765C2.80487 14.4788 2.75 14.3463 2.75 14.2082V8.479L4.69587 4.10081C4.73678 4.00874 4.80352 3.93052 4.888 3.87562C4.97248 3.82072 5.07106 3.7915 5.17181 3.7915H12.8282C12.9289 3.7915 13.0275 3.82072 13.112 3.87562C13.1965 3.93052 13.2632 4.00874 13.3041 4.10081L15.25 8.479V14.2082C15.25 14.3463 15.1951 14.4788 15.0975 14.5765C14.9998 14.6741 14.8673 14.729 14.7292 14.729Z",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSimple);
export default __webpack_public_path__ + "static/media/carSimple.cb9cc4ee3d0477174d5c8876b71415e7.svg";
export { ForwardRef as ReactComponent };